<template>
  <div class="facility-two-attributes">
    <StoryblokComponent
      v-for="attribute in blok.attributes"
      :key="attribute._uid"
      :blok="attribute"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
// 1 column for small screens
.facility-two-attributes {
  :deep(.facility-attribute) {
    @include pair-2;
    .even & {
      @include pair-7;
    }
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    margin-bottom: 0.5rem;
    width: 100%;
  }
}

// 2 columns for medium & large screens
@include for-tablet-portrait-up {
  .facility-two-attributes {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.83rem;

    :deep(.facility-attribute) {
      grid-column: span 1;
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
}
</style>
